module.exports = __webpack_public_path__ + "static/media/Style-Clubs-Serif.4cd8c44d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Style-Clubs-Serif.eot
// module id = 2909
// module chunks = 71